export const stringsKey = "ErrorPage";
export const englishStrings = {
	refreshLinkMessage: "Click here to refresh the page",
};
